import {ColumnsType} from "antd/lib/table";
import {DiscountCodeDto, DiscountType} from "../../api";
import {CrudTableWrapperProps} from "digimuth-components/dist/components/crudTable/crudTable";
import {CrudTable, nameof} from "digimuth-components/dist";
import {Tag} from "antd";
import moment from "moment";
import {discountTypeTranslation} from "../../helpers/DiscountTypeHelper";

export default function DiscountCodesList(props: CrudTableWrapperProps<DiscountCodeDto>) {
    const columns: ColumnsType<DiscountCodeDto> = [
        {
            key: nameof<DiscountCodeDto>("code"),
            dataIndex: nameof<DiscountCodeDto>("code"),
            title: "Kod",
            render: (code: string) => <strong>{code}</strong>
        }, {
            key: nameof<DiscountCodeDto>("expirationDate"),
            dataIndex: nameof<DiscountCodeDto>("expirationDate"),
            title: "Data ważności",
            render: (date: string) => date ? <Tag color={+new Date(date) >= +new Date() ? "green" : "red"}>
                {moment(date).format("DD-MM-YYYY HH:mm:ss")}
            </Tag> : null
        }, {
            key: nameof<DiscountCodeDto>("discountType"),
            dataIndex: nameof<DiscountCodeDto>("discountType"),
            title: "Typ obniżki",
            render: (discountType: DiscountType) => <Tag>
                {discountTypeTranslation(discountType)?.translation}
            </Tag>
        }, {
            key: nameof<DiscountCodeDto>("discountValue"),
            dataIndex: nameof<DiscountCodeDto>("discountValue"),
            title: "Wartność obniżki"
        }, {
            key: nameof<DiscountCodeDto>("minimumOrderAmount"),
            dataIndex: nameof<DiscountCodeDto>("minimumOrderAmount"),
            title: "Minimalna kwota zamówienia"
        }
    ];

    return <>
        <CrudTable
            data={props.data}
            onAddClicked={props.onAddClicked}
            onEditClicked={props.onEditClicked}
            onDeleteClicked={props.onDeleteClicked}
            isLoading={props.isLoading}
            columns={columns}
            addButtonTitle={"+ Dodaj nowy kod rabatowy"}
            editButtonTitle={"Edytuj"}
            deleteButtonTitle={"Usuń"}
            deleteConfirmMessage={"Czy na pewno chcesz usunąć ten wpis?"}
            cancelButtonTitle={"Anuluj"}
        />
    </>
}
